import React from "react";

const categories = [
  { title: "Adoption", image: "/assets/adoption-teal.png" },
  { title: "Animals & Pets", image: "/assets/animals-pets-teal.png" },
  { title: "Business", image: "/assets/business-teal.png" },
  { title: "Community", image: "/assets/community-teal.png" },
  { title: "Church", image: "/assets/church-teal.png" },
  { title: "Competitive", image: "/assets/competitive-teal.png" },
  { title: "Creative", image: "/assets/creative-teal.png" },
  { title: "Current Events", image: "/assets/event-teal.png" },
];

export default function Category() {
  return (
    <div className="bg-white text-center px-5 py-[60px] sm:py-10">
      {/* Heading */}
      <h2 className="text-[36px] font-semibold mb-2">Categories</h2>
      <p className="text-gray-500 mb-[45px]">
        Browse campaigns by category
      </p>

      {/* Grid */}
      <div className="grid gap-[25px] max-w-[1000px] mx-auto 
        grid-cols-2 
        sm:grid-cols-3 
        lg:grid-cols-4">

        {categories.map((item, index) => (
          <div
            key={index}
            className="bg-white border border-[#e3e6ea] 
              rounded-[18px] 
              px-5 py-[35px]
              sm:px-3 sm:py-5
              shadow-[0_6px_14px_rgba(0,0,0,0.06)]
              transition-all duration-300 cursor-pointer
              hover:-translate-y-[6px]
              hover:shadow-[0_12px_25px_rgba(45,148,103,0.35)]"
          >
            {/* Image */}
            <img
              src={item.image}
              alt={item.title}
              className={`mx-auto mb-[15px] object-contain
                w-[150px] h-[150px]
                md:w-[120px] md:h-[120px]
                sm:w-[90px] sm:h-[90px]
                ${
                  item.title === "Adoption" ||
                  item.title === "Animals & Pets" ||
                  item.title === "Creative"
                    ? "lg:w-[150px] lg:h-[150px] md:w-[135px] md:h-[135px] sm:w-[110px] sm:h-[110px]"
                    : ""
                }
              `}
            />

            {/* Title */}
            <h3 className="text-[18px] sm:text-[14px] font-medium">
              {item.title}
            </h3>
          </div>
        ))}
      </div>

      {/* View All Button */}
      <div className="mt-[50px]">
        <button
          className="text-white text-[18px] sm:text-[15px]
            px-[36px] py-[14px] sm:px-[28px] sm:py-[12px]
            rounded-[30px]
            bg-gradient-to-br from-[#28c76f] to-[#1e9fcf]
            shadow-[0_8px_20px_rgba(45,148,103,0.4)]
            transition-all duration-300
            hover:-translate-y-[3px]
            hover:shadow-[0_14px_30px_rgba(45,148,103,0.55)]"
        >
          View All Categories →
        </button>
      </div>
    </div>
  );
}
